import React from 'react';

interface HireMeScrollPopupProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  onHireMeClick: () => void;
}

const HireMeScrollPopup: React.FC<HireMeScrollPopupProps> = ({
  isOpen,
  onClose,
  email,
  onHireMeClick
}) => {
  return (
    <div
      className={`fixed bottom-4 left-4 z-50 transition-all duration-300 transform
        ${isOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'}`}
    >
      <div className="relative bg-white p-3 md:p-6 rounded-lg shadow-xl w-60 md:w-80">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="flex items-center mb-4">
          <div className="w-3 h-3 bg-green-500 rounded-full mr-2 animate-blink"></div>
          <p className=" text-sm md:text-base text-gray-700">Available for Freelance Work</p>
        </div>

        <button
          onClick={onHireMeClick}
          className="w-full px-2 py-2 md:px-4 md:py-3 bg-black text-white rounded-md text-lg font-semibold hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-opacity-50"
        >
          Hire Me
        </button>
      </div>
    </div>
  );
};

export default HireMeScrollPopup; 